import { Component, computed, Input, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { GalaxyAbstractFilterChip, GalaxyFilterValueInterface } from '@vendasta/galaxy/filter/chips';
import { takeUntilDestroyed, toObservable } from '@angular/core/rxjs-interop';
import { switchMap } from 'rxjs/operators';
import { CompanyDisplayName, CompanyFiltersService } from '../../../shared-services';

@Component({
  selector: 'crm-company-custom-filter-chip',
  template: `
    <ng-container *ngIf="selectedCompanyText(); else loading">
      {{ selectedCompanyText() }}
    </ng-container>
    <ng-template #loading>
      <div class="stencil-shimmer"></div>
    </ng-template>
  `,
  providers: [],
  styleUrls: ['./company-custom-filter-chip.component.scss'],
  imports: [CommonModule, TranslateModule],
})
export class CompanyCustomFilterChipComponent implements GalaxyAbstractFilterChip {
  selectedCompanyId = signal<string>('');
  selectedCompany = signal<CompanyDisplayName[]>([]);
  @Input() set initialValue(value: GalaxyFilterValueInterface[]) {
    if (value?.length > 0 && value[0].string) {
      this.selectedCompanyId.set(value[0].string);
    }
  }

  selectedCompanyText = computed(() => {
    if (this.selectedCompany().length === 0) {
      return '';
    }
    return this.selectedCompany()[0]?.displayName || this.selectedCompanyId();
  });

  constructor(private readonly companyFiltersService: CompanyFiltersService) {
    toObservable(this.selectedCompanyId)
      .pipe(
        switchMap((companyIds) => {
          return this.companyFiltersService.getMultiCompany([companyIds]);
        }),
        takeUntilDestroyed(),
      )
      .subscribe((result) => {
        this.selectedCompany.set(result);
      });
  }
}
